export interface TAddressFormsState {
    addressForms: boolean[];
  }
  
  export enum ActionTypes {
    TOGGLE_ADDRESS_FORM = '@@addressForms/TOGGLE_ADDRESS_FORM',
    RESET_ADDRESS_FORMS_STATE = '@@addressForms/RESET_ADDRESS_FORMS_STATE'
  }

